import styled from 'styled-components';
import { Star } from '../../svg';

interface IProps {
    className?: string;
    starAmount: number;
}

const BasePackageTitleStars = ({ className, starAmount }: IProps) => (
    <span className={className}>
        {[...Array(starAmount)].map((_, index) => (
            <Star key={index} />
        ))}
    </span>
);

export const PackageTitleStars = styled(BasePackageTitleStars)`
    display: inline-flex;

    ${Star} {
        margin-right: 4px;
    }
`;
